import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cómo recibo el producto después de comprar?',
    answer: 'Inmediatamente después de tu pago recibirás un enlace privado para descargar el ebook en PDF. No necesitas crear cuenta ni esperar envíos físicos.'
  }, {
    question: '¿Puedo hacerlo a cualquier hora del día?',
    answer: 'Sí. Puedes practicar R.E.V.E.L.A. por la mañana, al mediodía o antes de dormir. Recomendamos la mañana para ordenar el día desde la fe, pero lo más importante es la constancia, no el horario perfecto.'
  }, {
    question: '¿Funciona si estoy pasando por una crisis financiera real?',
    answer: 'El programa te ayuda a ordenar tu estado interior, reducir la ansiedad y dar pasos con mayor claridad y paz. No reemplaza asesoría financiera profesional, pero sí te ayuda a actuar desde la calma y la obediencia en vez del pánico.'
  }, {
    question: '¿Cuánto tiempo debo dedicarle cada día?',
    answer: 'Entre 10 y 15 minutos. En días más difíciles, con 5 minutos de R.E.V.E.L.A. básico es suficiente para mantener la constancia. La constancia diaria importa más que la duración perfecta.'
  }, {
    question: '¿Qué pasa si me salto un día?',
    answer: 'Nada grave. El programa incluye orientación para retomar sin culpa ni condena. La gracia de Dios siempre permite volver a empezar. La constancia importa más que la perfección.'
  }, {
    question: '¿Puedo compartir el archivo con alguien más?',
    answer: 'La licencia es de uso personal e intransferible. Si alguien cercano quiere el programa, puede adquirir su propia copia al mismo precio de lanzamiento.'
  }, {
    question: '¿En qué idioma está el contenido?',
    answer: 'Todo en español neutro, accesible para cualquier país hispanohablante.'
  }, {
    question: '¿Este programa reemplaza ir a la iglesia o al médico?',
    answer: 'No. Es un complemento espiritual y educativo para tu vida de fe. No reemplaza tu comunidad de fe, ni asesoría médica, psicológica, legal o financiera profesional de ningún tipo.'
  }];
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-39">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-41">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-12 text-center" data-id="element-42">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-43">
            {faqs.map((item, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-44">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-45">
                  <span className="font-semibold text-navy pr-4" data-id="element-46">
                    {index + 1}) {item.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-47" />
                </button>
                <AnimatePresence data-id="element-48">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-49">
                      <div className="px-6 pb-6 text-dark/80 leading-relaxed" data-id="element-50">
                        {item.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}